// tgx.js
// Tgx onpage JS integration.
import radio from 'radio';
import { RERENDER_ALL, NAV_MOVED, OWLCHANGE, OWLCHANGED } from 'shared/enums/events';

// Get the global TGX object or async stub/
const tgx = () => {
  window.time_dfp = window.time_dfp || [];
  return window.time_dfp;
};

const rerenderAllHandler = () => {
  // Asynchronously call tgx
  tgx().push(() => {
    tgx().processAds();
  });
};

// OWL Value Change Event
const carouselChange = (e, target) => {
  // Asynchronously call tgx
  try {
    tgx().galleryChange(e, target);
  } catch (err) {
    // Could not perform ad logic on gallery fail silently
    // probably something wrong with TGX
  }
};

export default () => {
  // Re-process page for new tags added after a rerender.
  radio(RERENDER_ALL).subscribe(rerenderAllHandler);
  radio(NAV_MOVED).subscribe(rerenderAllHandler);
  radio(OWLCHANGE).subscribe(carouselChange);
  radio(OWLCHANGED).subscribe(carouselChange);
};



// WEBPACK FOOTER //
// ./~/unicorn/public/src/utils/tgx.js